import * as React from 'react';
import parse from 'html-react-parser';


import { Button, Container, Row, Col } from 'react-bootstrap';
import { View, rem } from '../libs/WebComponents';
import IconButtonShadow from '../Components/IconButtonShadow';
import ButtonReadMore from '../Components/ButtonReadMore';
import {nl2br} from '../utils/utils-app';
import { Props } from '../types/types';
import { usePopupStore } from '../store/popups';
import { parsePostContent } from './parsePage';

const AppChapter = (props: Props) => {

   const { addPopup,removePopup } = usePopupStore();

   const _showReadMore = () => {
      const uuid = addPopup({type:'fullscreen chapter', closeButtonColor:'var(--color-white)', children: <View className={'popup-content'}>{parsePostContent({removePopup:()=>removePopup(uuid),content:props.page.post_content, firstname:props.firstname, goTo:props.goTo, index:props.index})}</View>});

   };
 

   return (
      <View className={'page'}>
         <View style={{paddingTop:rem(3)}}>
            <Container>
               <Row className={'align-items-center'}>
                  <Col className='col-12 text-center'>
                        <IconButtonShadow animate={true} name={'Number-'+props.chapter} size={rem(4)} iconColor={'var(--color-white'} color={'var(--color-purple)'} shadow={'var(--color-green)'} containerStyle={{marginBottom:rem(1)}}/>
                        <h3 style={{marginBottom:rem(4)}}>{props.page.post_title}</h3>
                  </Col>
               </Row>
               <Row>
                  <Col className='col-12 col-lg-6'>
                     <View className='featured-image mb-5'>{parse(props.page.featured_img)}</View>
                  </Col>
                  <Col className='col-12 col-lg-6'>
                     <View>
                        <div>{parsePostContent({content:props.page.post_excerpt?nl2br(props.page.post_excerpt):props.page.post_content.substring(0, 50), firstname:props.firstname, goTo:props.goTo, index:props.index})}</div>
                        {props.page.post_content !== ''?<ButtonReadMore onPress={_showReadMore} className={'align-self-center'} color={'var(--bs-body-background-color)'} style={{marginTop:rem(2)}}/>:null}
                        <Button onClick={()=>props.goTo(props.index+1)} className={'btn btn-success has-large-font-size align-self-center'} style={{marginTop:rem(3)}}>Verdergaan</Button>
                     </View>
                  </Col>
               </Row>
            </Container>
         </View>
   </View>
   );
}

export default React.memo(AppChapter);

